import { Colors } from '@oy/uicore';
import { Text } from '@oy/uidesktop';
import { IconName, SystemIcon } from '@oy/uiicon';
import classnames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { IS_DANARAPAY } from 'src/constants';
import { useTranslate } from 'src/hooks';
import { FeatureSuggestionModal } from './FeatureSuggestionModal/FeatureSuggestionModal';
import styles from './FloatingActionButton.module.css';
import { YellowMessenger } from './YellowMessenger/YellowMessenger';

interface FloatingActionButtonProps {
  showButton: boolean;
}

interface FabItemProps {
  onClick: () => void;
  text: string;
  iconName: IconName;
}

const FabItem = ({ onClick, text, iconName }: FabItemProps) => {
  const { getTranslation } = useTranslate();
  return (
    <div className={styles.fabItemContainer}>
      <Text
        textStyle={Text.Style.BodyLgSemibold}
        className={styles.fabItemNote}
        onClick={e => {
          e.stopPropagation();
          onClick();
        }}
      >
        {getTranslation(text)}
      </Text>
      <div
        onClick={e => {
          e.stopPropagation();
          onClick();
        }}
        className={styles.fabItem}
      >
        <SystemIcon name={iconName} color={Colors.BLACK100} />
      </div>
    </div>
  );
};

export const FloatingActionButton = ({
  showButton,
}: FloatingActionButtonProps) => {
  const { onClickButton } = YellowMessenger({ showButton });
  const buttonRef = useRef<HTMLDivElement | null>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [showFeatureSuggestionModal, setShowFeatureSuggestionModal] =
    useState(false);

  const onClickSuggestions = () => {
    setIsOpen(false);
    setIsHovered(false);
    setShowFeatureSuggestionModal(true);
  };

  const onClickYm = () => {
    setIsOpen(true);
    setIsHovered(true);
    onClickButton();
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Click outside handler
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
        setIsHovered(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        ref={buttonRef}
        className={styles.fabContainer}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => !isOpen && setIsHovered(false)}
      >
        <div className={classnames(styles.fabMenu, { [styles.open]: isOpen })}>
          <FabItem
            onClick={onClickSuggestions}
            text={'suggestFeature_title'}
            iconName="experiment"
          />
          {IS_DANARAPAY ? null : (
            <FabItem
              onClick={onClickYm}
              text={'common_contactCS'}
              iconName="headphone"
            />
          )}
        </div>
        <span
          className={classnames(styles.button, {
            [styles.hover]: isHovered,
            [styles.open]: isOpen,
          })}
          onClick={toggleMenu}
        >
          {!isOpen ? (
            <img src="/assets/customer-service.svg" />
          ) : (
            <SystemIcon name="close2" color={Colors.WHITE} />
          )}
        </span>
      </div>
      <FeatureSuggestionModal
        show={showFeatureSuggestionModal}
        onClose={() => {
          setShowFeatureSuggestionModal(false);
          setIsOpen(false);
          setIsHovered(false);
        }}
      />
    </>
  );
};
